import React, { useState, useEffect } from "react";
import { FaLongArrowAltLeft, FaUserShield, FaUser, FaShieldAlt, FaSave } from "react-icons/fa";
import { useNavigate, useParams } from "react-router-dom";
import {
  useGetSingleSubadminDetailsQuery,
  useUpdateSubadminMutation
} from "../redux/features/user/userApi";
import { toast } from "react-toastify";
import Navbar from "../Components/Navbar";
import PermissionsForm from "../Components/Kyc/PermissionsForm";
import { styles } from "../styles/style";

const EditSubadmin = () => {
  const [permissions, setPermissions] = useState([]);
  const { id } = useParams();
  const { data, isLoading, isSuccess, isError } = useGetSingleSubadminDetailsQuery(id);
  const [updateSubadmin, { isLoading: updateLoading, isSuccess: updateSuccess, data: updateData }] = useUpdateSubadminMutation();

  useEffect(() => {
    if (isSuccess && data.status === true) {
      toast.success(data.message);
      setPermissions(data?.data?.permission)

    } else if (isSuccess && data.status != true) {
      toast.error(data.message);
    }
  }, [isSuccess, data]);
  useEffect(() => {
    if (updateSuccess && updateData.status === true) {

      setPermissions(data?.data?.permission)
      toast.success(updateData.message);
      navigate(-1)

    } else if (updateSuccess && updateData.status != true) {
      toast.error(updateData.message);
    }
  }, [updateSuccess, updateData]);
  const navigate = useNavigate();


  const handleUpdate = async () => {
    const updatedData = {
      ...data?.data,
      permission: permissions,
    };
    await updateSubadmin(updatedData)
  }

  const { email, username, unique_id } = data?.data || "";

  return (
    <>
      <Navbar />
      <div className="min-h-screen bg-gradient-to-br from-gray-50 via-blue-50 to-purple-50 pt-20 px-4 sm:px-6 lg:px-8">
        <div className="max-w-6xl mx-auto py-8">
          {/* Header Section */}
          <div className="bg-white rounded-2xl shadow-lg p-6 mb-6 border border-gray-100">
            <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4">
              <div className="flex items-center gap-3">
                <div className="w-12 h-12 rounded-xl bg-gradient-to-br from-blue-500 to-purple-600 flex items-center justify-center shadow-lg">
                  <FaUserShield className="text-white text-xl" />
                </div>
                <div>
                  <h1 className="text-2xl sm:text-3xl font-bold bg-gradient-to-r from-blue-600 to-purple-600 bg-clip-text text-transparent">
                    Edit Subadmin
                  </h1>
                  <p className="text-gray-500 text-sm mt-1">Update subadmin details and permissions</p>
                </div>
              </div>
              <button
                onClick={() => navigate(-1)}
                className="inline-flex items-center gap-2 px-6 py-3 bg-white border-2 border-gray-200 text-gray-700 rounded-xl font-semibold hover:bg-gray-50 hover:border-gray-300 transition-all duration-300"
              >
                <FaLongArrowAltLeft className="text-gray-600" />
                <span>Back</span>
              </button>
            </div>
          </div>

          <form>
            {/* Personal Information Card */}
            <div className="bg-white rounded-2xl shadow-lg overflow-hidden border border-gray-100 mb-6">
              <div className="p-6 border-b border-gray-100 bg-gradient-to-r from-blue-50 to-purple-50">
                <h2 className="text-xl font-semibold text-gray-800 flex items-center gap-2">
                  <FaUser className="text-blue-600" />
                  Personal Information
                </h2>
              </div>

              <div className="p-6">
                <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
                  <div className="space-y-6">
                    <div>
                      <label className="block text-sm font-semibold text-gray-700 mb-2">User Name</label>
                      <input
                        className="w-full px-4 py-3 rounded-xl border-2 border-gray-300 bg-gray-50 focus:ring-4 focus:ring-gray-100 transition-all duration-200 outline-none text-gray-600 cursor-not-allowed"
                        type="text"
                        id="name"
                        name="name"
                        readOnly
                        value={username}
                      />
                    </div>

                    <div>
                      <label className="block text-sm font-semibold text-gray-700 mb-2">Unique Id</label>
                      <input
                        className="w-full px-4 py-3 rounded-xl border-2 border-gray-300 bg-gray-50 focus:ring-4 focus:ring-gray-100 transition-all duration-200 outline-none text-gray-600 cursor-not-allowed"
                        readOnly
                        value={unique_id}
                      />
                    </div>
                  </div>

                  <div className="space-y-6">
                    <div>
                      <label className="block text-sm font-semibold text-gray-700 mb-2">Email</label>
                      <input
                        className="w-full px-4 py-3 rounded-xl border-2 border-gray-300 bg-gray-50 focus:ring-4 focus:ring-gray-100 transition-all duration-200 outline-none text-gray-600 cursor-not-allowed"
                        type="email"
                        name="email"
                        id="email"
                        readOnly
                        value={email}
                      />
                    </div>

                    <div className="bg-grey rounded-xl p-4 border border-gray-200">
                      <div className="flex items-start gap-3">
                        <div className="w-8 h-8 rounded-lg bg-blue-500 flex items-center justify-center flex-shrink-0 mt-0.5">
                          <FaShieldAlt className="text-white" size={14} />
                        </div>
                        <div>
                          <h4 className="font-semibold text-gray-800 mb-1">Read-Only Fields</h4>
                          <p className="text-sm text-gray-600">Personal information fields are read-only and cannot be modified. Only permissions can be updated.</p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* Permissions Card */}
            <div className="bg-white rounded-2xl shadow-lg overflow-hidden border border-gray-100 mb-6">
              <div className="p-6 border-b border-gray-100 bg-gradient-to-r from-blue-50 to-purple-50">
                <h2 className="text-xl font-semibold text-gray-800 flex items-center gap-2">
                  <FaShieldAlt className="text-blue-600" />
                  Permissions
                </h2>
                <p className="text-gray-500 text-sm mt-1">Update access permissions for this subadmin</p>
              </div>
              <div className="p-6">
                <PermissionsForm permissions={permissions} setPermissions={setPermissions} />
              </div>
            </div>

            {/* Action Buttons */}
            <div className="flex flex-col sm:flex-row gap-4 justify-end">
              <button
                type="button"
                onClick={() => navigate(-1)}
                className="inline-flex items-center justify-center gap-2 px-8 py-3 bg-white border-2 border-gray-200 text-gray-700 rounded-xl font-semibold hover:bg-gray-50 hover:border-gray-300 transition-all duration-300"
              >
                Cancel
              </button>
              <button
                type="button"
                onClick={handleUpdate}
                className="inline-flex items-center justify-center gap-2 px-8 py-3 bg-gradient-to-r from-blue-500 to-purple-600 text-white rounded-xl font-semibold shadow-lg hover:shadow-xl hover:scale-105 transition-all duration-300"
              >
                <FaSave className="text-sm" />
                <span>Update Subadmin</span>
              </button>
            </div>
          </form>
        </div>
      </div>
    </>
  );
};

export default EditSubadmin;
